import React from 'react'; // import ArrowDropDown from '@material-ui/icons/ArrowDropDown';

import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon(stroke => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  stroke: stroke,
  strokeWidth: "0.5px",
  d: "M7 10l5 5 5-5z"
})), 'ArrowDropDown');